export default "__VITE_ASSET__et7Uur4j__"